export enum ActionStatus {
    open = "Open",
    inProgress = "In Progress",
    closed = "Closed",
}

export interface Action {
    ID: string; // '4652956',

    ActionByCustomer: string; // "Customer"
    ActionType: string; // "Proofing"
    AddedTS: string; // "2022-05-25 08:54:46.000"
    CardNumber: string; // "43884"
    DateDifference: string; // "253 days 8 hours"
    DateCompleted: string | null;
    FindingArea: string; // "Warehouse/Storage"
    FindingTypeRef: string; // "3",
    Findings: string; // "Warehouse roller door requires a better seal at the base
    MinDiff: string; // '364845',
    Price: string; // '.0000',
    Rating: "red" | "amber" | "green"; // red
    SiteName: string; // 'Birkenhead (Main) 0717',
    SiteRef: string; // '56911',
    Status: `${ActionStatus}`;
    TotalRows: string; // '1',
    VisitID: string; // '6891566'
    WorkInProgress: string; // 1 === In Progress 0 === Closed
    CommentCount: string; // Number as a string, so '0' or '1'
}

export interface ActionCount {
    ActionsCount: number;
}

export interface ActionComment {
    CreatedAt: string;
    Note: string;
    UpdateBy: string;
}
export interface ActionImage {
    AmazonGUID: string;
    Deleted: string;
    ID: string;
    Note: string;
    Photo?: string;
    RefGuid: string;
    TS: string;
    VisitID: string;
}
